import React from "react";
import * as ReactDOM from "react-dom/client";
import {
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { message } from "antd";

import "locales/i18n";
import "styles/global.less";

import msalInstance from "utils/msal";
import App from "./App";

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback(async (event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const { account } = payload;
    msalInstance.setActiveAccount(account);
    message.success("Login Successfuly");
  }
});

const container = document.getElementById("root");

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App msalInstance={msalInstance} />
    </React.StrictMode>
  );
}
